/**
 * Header component.
 * @module components/theme/Header/Header
 */

import { Image } from 'semantic-ui-react';
import LeadVideo from '@package/components/LeadVideo/LeadVideo';
import React from 'react';
import { connect } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers';
import { getContent } from '@plone/volto/actions';
import { resetContent } from '@plone/volto/actions/content/content';
import { srcset } from '@package/helpers';

const SmallHeaderFor = [
  //'Esperienza',
  'SchedaTematica',
  'Event',
  'Itinerario',
  'StrutturaRicettiva',
  'Ristorante',
  'Storia',
];

const HideTitleFor = [
  'Esperienza',
  'SchedaTematica',
  'Event',
  'Itinerario',
  'StrutturaRicettiva',
  'Ristorante',
  'Storia',
];

const NoLeadImageFor = ['News Item'];
/**
 * LeadImage component class.
 * @class Header
 * @extends Component
 */

const LeadImage = (props) => {
  const { content } = props;

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */

  if (content) {
    const contentType = content['@type'];
    const showTitle = !(HideTitleFor.indexOf(contentType) >= 0);
    const image = content?.image?.scales?.leadimage;
    const videoUrl = content?.video?.download;
    const videoMimeType = content?.video?.['content-type'];

    let height = image?.height ?? 0;
    if (videoUrl) {
      height = 770;
    }
    if (SmallHeaderFor.indexOf(contentType) >= 0) {
      height = 400;
    }
    if (contentType === 'Esperienza') {
      height = 700;
    }
    if (contentType === 'Event') {
      height = 700;
    }
    if (NoLeadImageFor.indexOf(contentType) >= 0) {
      return null;
    }

    return (
      <>
        {image || videoUrl ? (
          <div
            className={`lead-image ${videoUrl ? 'lead-video' : ''}`}
            id="leadimage-portal"
            style={{ height: height + 'px' }}
          >
            {videoUrl ? (
              <>
                <LeadVideo
                  poster={
                    image?.download ? flattenToAppURL(image.download) : null
                  }
                  url={videoUrl}
                  mimeType={videoMimeType}
                />
              </>
            ) : (
              <>
                <Image
                  src={flattenToAppURL(image.download)}
                  alt={content?.title ?? ''}
                  loading="lazy"
                  srcSet={srcset(flattenToAppURL(image.download), 'leadimage')}
                  key={image.download}
                />
                {content.title && showTitle && <h1>{content.title}</h1>}
              </>
            )}
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
  return <div id="leadimage-portal"></div>; // serve  per la pagina della wishlist e per il blocco slider
};

export default connect(
  (state) => ({
    content: state.content.data,
    subrequests: state.content.subrequests,
  }),
  { getContent, resetContent },
)(LeadImage);
